'use client';

import { c as _c } from "react/compiler-runtime";
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../../components/InputOTP';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { BaseFieldProps } from './types';
export interface TotpInputComponentProps {
  id?: string;
  className?: string;
  disabled?: boolean;
  /** Number of digits. Defaults to 6 */
  maxLength?: number;
  /** Called when all digits have been entered */
  onComplete?: (value: string) => void;
}
interface TotpInputFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: TotpInputComponentProps;
}
export function TotpInputField(t0) {
  const $ = _c(35);
  const {
    field,
    fieldConfig,
    fieldState,
    componentProps,
    labelSize
  } = t0;
  let componentDisabled;
  let id;
  let onComplete;
  let restProps;
  let t1;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      maxLength: t1,
      onComplete,
      ...restProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = componentDisabled;
    $[2] = id;
    $[3] = onComplete;
    $[4] = restProps;
    $[5] = t1;
  } else {
    componentDisabled = $[1];
    id = $[2];
    onComplete = $[3];
    restProps = $[4];
    t1 = $[5];
  }
  const maxLength = t1 === undefined ? 6 : t1;
  const isDisabled = field.disabled || componentDisabled;
  let t2;
  if ($[6] !== fieldConfig || $[7] !== fieldState || $[8] !== id) {
    t2 = getFieldIds(fieldConfig, fieldState, id);
    $[6] = fieldConfig;
    $[7] = fieldState;
    $[8] = id;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const ids = t2;
  const halfLength = Math.ceil(maxLength / 2);
  const t3 = field.value as string ?? "";
  let t4;
  if ($[10] !== halfLength) {
    t4 = <InputOTPGroup className="gap-2 flex-1">{Array.from({
        length: halfLength
      }, _temp)}</InputOTPGroup>;
    $[10] = halfLength;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== halfLength || $[13] !== maxLength) {
    let t6;
    if ($[15] !== halfLength) {
      t6 = (__0, i_0) => <InputOTPSlot className="h-[60px] flex-1 rounded border text-xl" index={halfLength + i_0} key={halfLength + i_0} />;
      $[15] = halfLength;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    t5 = <InputOTPGroup className="gap-2 flex-1">{Array.from({
        length: maxLength - halfLength
      }, t6)}</InputOTPGroup>;
    $[12] = halfLength;
    $[13] = maxLength;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[17] !== field.onChange || $[18] !== ids.describedBy || $[19] !== ids.fieldId || $[20] !== ids.isInvalid || $[21] !== isDisabled || $[22] !== maxLength || $[23] !== onComplete || $[24] !== restProps || $[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t6 = <InputOTP {...restProps} aria-describedby={ids.describedBy} aria-invalid={ids.isInvalid} containerClassName="w-full" disabled={isDisabled} id={ids.fieldId} maxLength={maxLength} onChange={field.onChange} onComplete={onComplete} pattern={REGEXP_ONLY_DIGITS} value={t3}>{t4}{t5}</InputOTP>;
    $[17] = field.onChange;
    $[18] = ids.describedBy;
    $[19] = ids.fieldId;
    $[20] = ids.isInvalid;
    $[21] = isDisabled;
    $[22] = maxLength;
    $[23] = onComplete;
    $[24] = restProps;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== fieldConfig || $[30] !== fieldState || $[31] !== ids || $[32] !== labelSize || $[33] !== t6) {
    t7 = <FieldShell className="flex-1 flex flex-col items-start" fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t6}</FieldShell>;
    $[29] = fieldConfig;
    $[30] = fieldState;
    $[31] = ids;
    $[32] = labelSize;
    $[33] = t6;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  return t7;
}
function _temp(_, i) {
  return <InputOTPSlot className="h-[60px] flex-1 rounded border text-xl" index={i} key={i} />;
}